import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa6";
import styles from "./Footer.module.css";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandCol}>
          <span className={styles.brandTitle}>MY Adventures</span>
          <p className={styles.brandTagline}>
            The Maldives' favourite floating dive centre. Daily dives, PADI
            courses and ocean adventures with Moocho, Sajee and the team.
          </p>
        </div>

        <div className={styles.linkCol}>
          <span className={styles.eyebrow}>Explore</span>
          <Link to="/" className={styles.link}>Home</Link>
          <Link to="/my-dive" className={styles.link}>My Dive</Link>
          <HashLink smooth to="/#contact" className={styles.link}>Contact</HashLink>
        </div>

        <div className={styles.linkCol}>
          <span className={styles.eyebrow}>On the boat</span>
          <HashLink smooth to="/my-dive#about" className={styles.link}>About</HashLink>
          <HashLink smooth to="/my-dive#activities" className={styles.link}>Activities</HashLink>
          <HashLink smooth to="/my-dive#team" className={styles.link}>The team</HashLink>
        </div>

        <div className={styles.socialCol}>
          <span className={styles.eyebrow}>Follow</span>
          <div className={styles.socials}>
            <a className={styles.social} href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a className={styles.social} href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a className={styles.social} href="/#contact" aria-label="Get in touch">
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>

      <div className={styles.rule} />

      <div className={styles.legal}>
        <span>© {year} MY Adventures</span>
        <span className={styles.dot} aria-hidden>·</span>
        <span>Crafted in the Maldives</span>
      </div>
    </footer>
  );
};
